import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import LoginPage from './modules/admin/LoginPage/LoginPage';
import DataManagement from './modules/admin/DataManagement/DataManagement';
import ShowcaseWebsite from './modules/website/ShowcaseWebsite/ShowcaseWebsite';
import LandingPage from './modules/website/LandingPage/LandingPage';
import { CommonConfigProvider } from './components/CommonConfigProvider';
import AuthGuard from './components/common/AuthGuard/AuthGuard';
import './styles/App.css';

// 设置dayjs默认语言为中文
dayjs.locale('zh-cn');

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            {/* 数据管理路由需要登录验证 - 不需要通用配置 */}
            <Route 
              path="/data/*" 
              element={
                <AuthGuard requireAuth={true}>
                  <DataManagement />
                </AuthGuard>
              } 
            />
            {/* 网站端路由 - 需要通用配置，只在刷新时调用一次 */}
            <Route 
              path="/show" 
              element={
                <CommonConfigProvider>
                  <LandingPage />
                </CommonConfigProvider>
              } 
            />
            <Route 
              path="/show/*" 
              element={
                <CommonConfigProvider>
                  <ShowcaseWebsite />
                </CommonConfigProvider>
              } 
            />
            <Route path="/" element={<Navigate to="/show" replace />} />
          </Routes>
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;